import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class NetworkErrorInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof ProgressEvent) {
          console.error('Network error on request:', req.method, req.urlWithParams);
          console.error('Raw error:', error);
          console.error('ProgressEvent details:', {
            type: error.error.type,
            loaded: error.error.loaded,
            total: error.error.total,
            lengthComputable: error.error.lengthComputable
          });
          const networkError = new HttpErrorResponse({
            error: {
              message: 'A network error occurred. This is commonly caused by a VPN, firewall, or browser extension blocking the request. Please check your network connection and try again.'
            },
            headers: error.headers,
            status: 0,
            statusText: 'Network Error',
            url: error.url
          });
          return throwError(() => networkError);
        }
        return throwError(() => error);
      })
    );
  }
}
